import styled from "styled-components";
import { ReactComponent as ChevronIcon } from "../../assets/icons/chevronLeft.svg";

export const PaginationContainer = styled.ul`
  display: flex;
  gap: 8px;
`;

export const ArrowContainer = styled.li`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: 1px solid #333;
  background: transparent;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: ${({ disabled }) => !disabled && "#333"};
    border-color: #2877D9;
  }

  opacity: ${({ disabled }) => disabled && 0.4};
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  pointer-events: ${({ disabled }) => disabled && "none"};
`;

export const ArrowIcon = styled(ChevronIcon)`
  color: ${(props) => (props.$disabled ? "#A9A9A970" : "#1672BA")};
`;

export const RightArrowIcon = styled(ArrowIcon)`
  transform: rotate(180deg);
`;

export const PaginationItem = styled.li`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  height: 40px;
  padding: 0 8px;
  pointer-events: ${({ selected }) => selected && "none"};
  cursor: ${({ selected }) => (selected ? "not-allowed" : "pointer")};
  border: 1px solid ${({ selected }) => (selected ? "#2877D9" : "#333")};
  background: ${({ selected }) => (selected ? "#2877D9" : "transparent")};
  color: ${({ selected }) => (selected ? "#fff" : "#fff")};
  border-radius: 8px;
  transition: all 0.2s ease;
  font-family: DM Sans;
  font-weight: 500;
  font-size: 14px;

  &:hover {
    background: ${({ selected }) => (selected ? "#2877D9" : "#333")};
  }
`;
